import { Typography } from '@epilot/concorde-elements'
import type { StepExtended } from '@epilot/journey-logic-commons'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './StepHeader.module.scss'

const RequiredLabel = () => {
  const { t } = useTranslation()

  return (
    <Typography className={classes.requiredLabel} color="secondary">
      {'* ' + t('input_required', 'Pflichteingabe')}
    </Typography>
  )
}

export const StepHeader = ({
  step,
  hasRequiredField,
  className
}: {
  step: StepExtended
  hasRequiredField: boolean
  className?: string
}) => {
  return (
    <div
      className={classNames(
        'Concorde-Layout-Header',
        classes.stepHeaderContainer,
        !step.showStepName &&
          !step.showStepSubtitle &&
          !hasRequiredField &&
          classes.noStepHeaderPadding,
        className
      )}
    >
      <div
        className={classNames(classes.stepTitleContainer, {
          [classes.spaceBetween]: step.showStepName,
          [classes.flexEnd]: !step.showStepName
        })}
      >
        {step.showStepName && (
          <Typography
            as="h2"
            className={classNames(
              classes.stepName,
              !!step.showStepSubtitle && classes.zeroMarginBottom
            )}
          >
            {step.title === undefined ? step.name : step.title}
          </Typography>
        )}

        {hasRequiredField && <RequiredLabel />}
      </div>

      {step.showStepSubtitle && (
        <Typography className={classes.subtitle}>{step.subTitle}</Typography>
      )}
    </div>
  )
}
